<h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">{{user?.userId ? "Edit" : "Create"}} User</h2>
<div class="editUser"
     *ngIf='user'
     style="margin: 10px 10px 10px 10px">
  <div>
    <alert></alert>
  </div>
  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">
    <div style="flex:60px">
      <mat-form-field style='width: 60px'>
        <mat-label>Title</mat-label>
        <mat-select  [(ngModel)]="user.title" id="title">
          <mat-option [value]="1">Mr.</mat-option>
          <mat-option [value]="2">Ms.</mat-option>
          <mat-option [value]="3">Mrs.</mat-option>
          <mat-option [value]="4">Miss</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="flex:10px"></div>

    <div style="flex:45%">
      <mat-form-field class="example-full-width">
        <mat-label>First Name</mat-label>
        <input matInput  name="firstName" [(ngModel)]="user.firstName" required>
      </mat-form-field>
    </div>

    <div style="flex:10px"></div>

    <div style="flex:45%">
      <mat-form-field class="example-full-width">
        <mat-label>Last Name</mat-label>
        <input matInput  name="lastName" [(ngModel)]="user.lastName" required>
      </mat-form-field>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

    <div class="form-group" style="flex:70%">
      <mat-form-field style="width: 87%;">
        <mat-label>Email Address</mat-label>
        <input matInput  name="emailAddress" [(ngModel)]="user.emailAddress" required>
      </mat-form-field>
    </div>

    <div class="form-group" style="flex:40%">
      <mat-form-field>
        <mat-label>Role</mat-label>
        <mat-select  [(ngModel)]="user.role" name="role" required>
          <mat-select-trigger>{{roles[user.role]}}</mat-select-trigger>
          <mat-option [value]="1"
                      *ngIf="(!externalRoles || externalRoles.indexOf(1) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][1] || !isSelfEdit)">
            User
            <div class="tooltip-trigger"
                 pTooltip='“User" and “Advisor Staff” have the ability to access existing projects and complete control items'>

            </div>
          </mat-option>
          <mat-option [value]="4"
                      *ngIf="(!externalRoles || externalRoles.indexOf(4) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][4] || !isSelfEdit)">
            Manager
            <div class="tooltip-trigger"
                 pTooltip='“Managers” and “Advisor Leads” have the ability to create new projects and invite new users'>

            </div>
          </mat-option>
          <mat-option [value]="2"
                      *ngIf="(!externalRoles || externalRoles.indexOf(2) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][2] || !isSelfEdit)">
            Advisor Staff
            <div class="tooltip-trigger"
                 pTooltip=' “User” and “Advisor Staff” have the ability review completed items.  '>

            </div>
          </mat-option>
          <mat-option [value]="8"
                      *ngIf="(!externalRoles || externalRoles.indexOf(8) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][8] || !isSelfEdit)">
            Advisor Lead
            <div class="tooltip-trigger"
                 pTooltip='“Managers” and “Advisor Leads” have the ability to create new projects and invite new users'>

            </div>
          </mat-option>
          <mat-option [value]="64"
                      *ngIf="(!externalRoles || externalRoles.indexOf(64) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][64] || !isSelfEdit)">
            Vendor
            <div class="tooltip-trigger"
                 pTooltip='Need partner description'>

            </div>
          </mat-option>
          <mat-option [value]="32"
                      *ngIf="(!externalRoles || externalRoles.indexOf(32) >= 0) && isMaster && (allowedSelfEditRoles[currentUserRole][32] || !isSelfEdit)">
            King Admin
            <div class="tooltip-trigger"
                 pTooltip='Tenant Manager'>

            </div>
          </mat-option>
          <mat-option [value]="128"
                      *ngIf="(!externalRoles || externalRoles.indexOf(128) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][128] || !isSelfEdit)">
            Awareness
            <div class="tooltip-trigger"
                 pTooltip='Have access to awareness'>

            </div>
          </mat-option>
          <mat-option [value]="256"
                      *ngIf="(!externalRoles || externalRoles.indexOf(256) >= 0) && isMaster && (allowedSelfEditRoles[currentUserRole][256] || !isSelfEdit)">
            Admin
            <div class="tooltip-trigger"
                 pTooltip='Can manage controls, training and bulletins'>

            </div>
          </mat-option>
          <mat-option [value]="512"
                      *ngIf="(!externalRoles || externalRoles.indexOf(512) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][512] || !isSelfEdit)">
            Assessor
            <div class="tooltip-trigger"
                 pTooltip='Can view assigned project details'>

            </div>
          </mat-option>
          <mat-option [value]="1024"
                      *ngIf="(!externalRoles || externalRoles.indexOf(1024) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][1024] || !isSelfEdit)">
            Survey
            <div class="tooltip-trigger"
                 pTooltip='Can finish survey'>

            </div>
          </mat-option>
          <mat-option [value]="2048"
                      *ngIf="(!externalRoles || externalRoles.indexOf(2048) >= 0) && !isMaster && user.role == 2048">
            Advisor Admin
            <div class="tooltip-trigger"
                 pTooltip='Same as Advisor Lead but can edit Account Profile'>

            </div>
          </mat-option>
          <mat-option [value]="4096"
                      *ngIf="(!externalRoles || externalRoles.indexOf(4096) >= 0) && !isMaster && user.role == 4096">
            Customer Administrator
            <div class="tooltip-trigger"
                 pTooltip='Same as Advisor Lead but can edit Account Profile'>

            </div>
          </mat-option>
          <mat-option [value]="8192"
                      *ngIf="(!externalRoles || externalRoles.indexOf(8192) >= 0) && isMaster && (allowedSelfEditRoles[currentUserRole][8192] || !isSelfEdit)">
            Support
            <div class="tooltip-trigger"
                 pTooltip='Master Support user'>

            </div>
          </mat-option>
          <mat-option [value]="16384"
                      *ngIf="(!externalRoles || externalRoles.indexOf(16384) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][16384] || !isSelfEdit)">
            Incident Response
            <div class="tooltip-trigger"
                 pTooltip='Incident Response user'>

            </div>
          </mat-option>
          <mat-option [value]="32768"
                      *ngIf="(!externalRoles || externalRoles.indexOf(32768) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][32768] || !isSelfEdit)">
            Workstream
            <div class="tooltip-trigger"
                 pTooltip='Workstream works with Workstreams'>

            </div>
          </mat-option>
          <mat-option [value]="65536"
                      *ngIf="(!externalRoles || externalRoles.indexOf(65536) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][65536] || !isSelfEdit)">
            Platform Support
            <div class="tooltip-trigger"
                 pTooltip='Platform Support - same as Advisor Admin'>

            </div>
          </mat-option>
          <mat-option [value]="131072"
                      *ngIf="(!externalRoles || externalRoles.indexOf(131072) >= 0) && !isMaster && (allowedSelfEditRoles[currentUserRole][131072] || !isSelfEdit)">
            Trust Center Viewer
            <div class="tooltip-trigger"
                 pTooltip='Trust Center Viewer - no access to other pages'>

            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>City</mat-label>
        <input matInput  name="city" [(ngModel)]="user.city">
      </mat-form-field>
    </div>

    <div style="flex:20%"></div>

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>State</mat-label>
        <input matInput  name="state" [(ngModel)]="user.state">
      </mat-form-field>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>Phone</mat-label>
        <input matInput  name="phone" [(ngModel)]="user.phone">
      </mat-form-field>
    </div>

    <div style="flex:20%"></div>

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>Fax</mat-label>
        <input matInput  name="fax" [(ngModel)]="user.fax">
      </mat-form-field>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
    <div class="form-group" style="flex:50%">
      <mat-form-field>
        <mat-label>Secret Question 1</mat-label>
        <mat-select  [(value)]="user.secretQuestion1">
          <mat-option *ngFor="let question of getSecretQuestions()" [value]="question">
            {{ question }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="flex:20%"></div>

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>Answer1</mat-label>
        <input matInput  name="secretAnswer1" [(ngModel)]="user.secretAnswer1">
      </mat-form-field>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

    <div class="form-group" style="flex:50%">
      <mat-form-field>
        <mat-label>Secret Question 2</mat-label>
        <mat-select  [(value)]="user.secretQuestion2">
          <mat-option *ngFor="let question of getSecretQuestions()" [value]="question">
            {{ question }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="flex:20%"></div>

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>Answer 2</mat-label>
        <input matInput  name="secretAnswer2" [(ngModel)]="user.secretAnswer2">
      </mat-form-field>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

    <div class="form-group" style="flex:50%">
      <mat-form-field>
        <mat-label>Secret Question 3</mat-label>
        <mat-select  [(value)]="user.secretQuestion3">
          <mat-option *ngFor="let question of getSecretQuestions()" [value]="question">
            {{ question }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="flex:20%"></div>

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>Answer 3</mat-label>
        <input matInput  name="secretAnswer3" [(ngModel)]="user.secretAnswer3">
      </mat-form-field>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

    <div class="form-group" style="flex:50%" *ngIf="isConsultantManager()">
      <mat-form-field>
        <mat-label>Department</mat-label>
        <mat-select  [(ngModel)]="user.department" name="role">
          <mat-option [value]="1">HR</mat-option>
          <mat-option [value]="2">Sales</mat-option>
          <mat-option [value]="3">Marketing</mat-option>
          <mat-option [value]="4">IT</mat-option>
          <mat-option [value]="5">Audit</mat-option>
          <mat-option [value]="6">Client Service</mat-option>
          <mat-option [value]="7">Engineering</mat-option>
          <mat-option [value]="8">Operations</mat-option>
          <mat-option [value]="9">Field</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="flex:20%"></div>

    <div class="form-group" style="flex:50%">
      <mat-form-field class="example-full-width">
        <mat-label>Company Name</mat-label>
        <input matInput  name="companyName" [(ngModel)]="user.companyName"
               [readonly]="isBossUser"
               [required]="user.role == 64" />
      </mat-form-field>
    </div>
  </div>
  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start"
       *ngIf="isConsultantManager()">
    <div class="form-group" style="flex:50%">
      <mat-checkbox class="example-margin"
                    [(ngModel)]="isSimpleView"
                    name="simpleView">Simple View
      </mat-checkbox>
    </div>
    <div class="form-group" style="flex:50%">
      <mat-checkbox class="example-margin"
                    [(ngModel)]="user.enableMfa"
                    name="simpleView">Multi-factor login
      </mat-checkbox>
    </div>
  </div>

</div>
<div style="display: flex; flex-direction: row; justify-content: start; align-items: start" *ngIf="user">
  <button mat-raised-button
          [disabled]="loading"
          style="border-radius: 6px;"
          mwlConfirmationPopover
          [popoverTitle]="this.constants.WARNING_PERSONAL_INFO_TITLE"
          [popoverMessage]="this.constants.WARNING_PERSONAL_MESSAGE"
          popoverClass="confirmation-popover-hide-popover-arrow"
          [hideCancelButton]="true"
          placement="top-left"
          (confirm)="onSave()"
          confirmText="{{this.constants.LBL_I_UNDERSTAND}}">
    Save
  </button>
  <img *ngIf="loading"
       src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />

  <button mat-raised-button
          [disabled]="loading"
          style="border-radius: 6px;"
          *ngIf="user?.userId && !isSelfEdit"
          (click)="onInvite()">Invite
  </button>
</div>
